import { GET_PROJECT_API } from '../commons/constants/apis';
import { ResponseTypes } from '../types/response/common';
import { QuestionRequestType, QuestionType } from '../types/question.type';
import axios from './axios';

export const getQuestionsByProjectKey = async (
  request: QuestionRequestType
): Promise<QuestionType[]> => {
  const { data }: ResponseTypes<QuestionType[]> = await axios.get(
    `${GET_PROJECT_API}/${request.key}/questions`,
    {
      headers: { language: request.language },
      params: { type: request.type, tags: request.tags },
    }
  );
  return data;
};
